import { EntityService } from 'src/app/core/services/entity.service';
import { Entity } from 'src/app/core/models/entity.model';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Team } from 'src/app/core/models/team.model';
import { UserService } from 'src/app/core/services/user.service';
import * as utils from 'src/app/shared/helpers/utils';
import * as adminTools from 'src/app/shared/helpers/utils';
import { User } from 'src/app/core/models/user.model';
import { Location } from '@angular/common';
import { ConfigService } from 'src/app/core/services/config.service';
import { CustomValidators } from 'src/app/shared/helpers/custom-validators';
import { map, Subscription, tap } from 'rxjs';
import { Config } from 'src/app/core/models/config.model';

@Component({
  selector: 'hbo-team-actions',
  templateUrl: './team-actions.component.html',
  styleUrls: ['./team-actions.component.scss']
})
export class TeamActionsComponent implements OnInit, AfterViewInit {

  @Input() team!: Team;
  @Output() reload: EventEmitter<any> = new EventEmitter();
  @Output() callback: EventEmitter<any> = new EventEmitter();

  @Input() user!: User;

  action = 'create';

  entities: Entity[] = [];
  entity!: Entity;
  reactiveToRole = 4;

  entityId: FormControl<number | null> = new FormControl(null);

  utils = utils;

  teamForm = this.formBuilder.nonNullable.group({
    id: [0],
    name: ['', Validators.required],
    entityId: this.entityId || null
  });

  persistEntityId!: number | null;
  parentEntities: Entity[] = [];

  teamFormLstnr: Subscription = new Subscription();

  partialTeams:Team[]=[];

  constructor(
    public configSvc: ConfigService,
    private formBuilder: FormBuilder,
    private router: Router,
    private userService: UserService,
    private entityService: EntityService,
    private location: Location
  ) {
    if (!this.user) this.user = utils.localStorageGetItem('user');
    if (this.user) this.user.childEntities = this.configSvc.currentConfigValue.childEntities;

  }

  ngOnInit() {
    if (!this.team) {
      this.team = { id: 0 } as Team;
    } else {
      this.action = 'edit';
    }

    if (this.user.roleId == 1) {
      this.teamForm.get('entityId')?.setValidators(Validators.required);
    }
    else { this.teamForm.controls.entityId.patchValue(this.user.entityId) };

    this.persistEntityId = this.teamForm.controls.entityId.value;

    /*let parentEntities = utils?.localStorageGetItem('parentEntities')!;
    if (parentEntities) this.entities = this.configSvc.currentConfigValue.childEntities!.filter((entity: Entity) => entity.entityTypeId === 2);*/

    this.setParents();
    /*if (!this.entities.length) {
      //this.entityService.getOnlyParents().subscribe(entities => {
        this.entities = this.configSvc.currentConfigValue.childEntities!;
        //utils.localStorageSetItem('parentEntities', this.entities);
        this.entities = this.entities.filter((entity: Entity) => entity.entityTypeId === 2);
        console.log(this.entities);
      //});
    }*/
    if (!this.entities.length) this.entities.push(this.user.entity);
    this.teamFormLstnr = this.teamForm.controls.entityId.valueChanges.subscribe(value =>{
      this.teamForm.controls.name.patchValue(this.team.name ?? '');
      this.partialTeams = this.configSvc.currentConfigValue.teams?.filter((t:Team)=> t.entity.id === value)!;
    })
    if (this.action === 'create') this.getTeams();
    else this.setTeamNameUsedValidator(this.configSvc.currentConfigValue!.teams!);

  }

  setParents = () => {
    const propsToRemove = ['children', 'parentEntity', 'parentEntityId'];
    let parentEntities = this.configSvc.currentConfigValue.childEntities!.filter((entity: Entity) => entity.entityTypeId === 2);
    this.parentEntities = parentEntities.map(obj => {
      const newObj: any = { ...obj };
      propsToRemove.forEach((prop: any) => delete newObj[prop]);
      return newObj;
    });
  }


  ngAfterViewInit() {
    if (this.team && this.team.id !== 0) {
      this.entity = this.team.entity;
      this.teamForm.patchValue({
        id: this.team.id,
        name: this.team.name,
        entityId: this.team.entity.id
      });

    } else {
      if (this.user.roleId !== 1) this.teamForm.patchValue({ entityId: this.user.entityId });
    }

    this.entity = this.configSvc.currentConfigValue.childEntities!.find((item: Entity) => item.id == this.team.entity?.id)!;

    if (!this.entity && this.user) this.entity = this.user.entity;

    // Disable form for view-only users (profileId = 2) or for non-owner distributor users
    if (this.user.profileId === 2 || (this.user.roleId === 2 && this.user.profileId !== 3)) {
      this.teamForm.disable();
    }

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipTriggerList.forEach(tooltipTrigger => new window['bootstrap' as keyof typeof window].Tooltip(tooltipTrigger));

  }

  save() {
    this.teamForm.markAllAsTouched();
    if (this.teamForm.valid) {
      this.teamForm.controls.name.patchValue(this.teamForm.controls.name.value.trim());
      if (this.action === 'create') {
        this.userService.createTeam({ ...this.teamForm.value } as unknown as Team).subscribe(res => {
          let entity: Entity = new Entity;
          entity.id = res.entityId;
          if (entity.id === this.entity.id) entity.name = this.entity.name;
          else entity.name = this.configSvc.currentConfigValue.childEntities?.find((entity: Entity) => entity.id === res.entityId)!.name!;
          this.configSvc.currentConfigValue.teams?.push({ ...res, entity: entity });
          this.configSvc.setConfigParamsValue('teams', this.configSvc.currentConfigValue.teams);
          this.router.navigate(['users/teams']);
        });
      } else if (this.action === 'edit') {
        this.userService.updateTeam({ ...this.teamForm.value } as unknown as Team).subscribe(res => {
          //this.reload.emit();
          utils.deepMerge(this.configSvc.currentConfigValue.teams?.find((t: Team) => t.id === Number(this.teamForm.controls.id.value)), res);
          this.configSvc.setConfigParamsValue('teams', this.configSvc.currentConfigValue.teams);
          this.callback.emit({ action: 'updated', result: res });
        });
      }
    }
  }

  delete() {
    this.userService.deleteTeam(this.team.id).subscribe({
      next: res => {
        switch (res.body) {
          // Kept for older responses: a referenced team now comes back as a 409,
          // so this branch is unreachable against the current backend.
          case 'TEAMREFERENCED':
            //TO DO
            utils.toogleModal('#confirmationModal-team-delete', false)
            break;
          case 'TEAMDELETED':
            this.configSvc.currentConfigValue.teams = this.configSvc.currentConfigValue.teams?.filter((t: Team) => t.id !== this.team.id);
            this.configSvc.setConfigParamsValue('teams', this.configSvc.currentConfigValue.teams);
            this.callback.emit({ action: 'deleted' });
            break;
          default:
            break;
        }
      },
      // The team is still assigned to a user or an entity: close the dialog and
      // leave the list untouched. The toast interceptor reports the failure.
      error: () => utils.toogleModal('#confirmationModal-team-delete', false)
    });
  }

  cancel() {
    if (this.action === 'create') {
      this.location.back();
    } else {
      this.teamForm.patchValue({
        name: this.team.name ?? ''
      })
    }
  }

  onChange(id: number, _type?: string) {
    switch (_type) {
      case 'entity':
        this.teamForm.controls.entityId.patchValue(id);
        break;
      default:
        break;
    }
  }

  getTeams = () => {
    this.userService.getTeams({ perPage: -1 }, true).subscribe(res => {
      this.configSvc.setConfigParamsValue('teams', res.data);
      this.setTeamNameUsedValidator(res.data);
      this.partialTeams = res.data?.filter((t:Team)=> t.entity.id === this.teamForm.controls.entityId.value)!;
    });
  }

  setTeamNameUsedValidator = (_teams: Team[]) => {
    this.teamForm.get('name')!.addValidators([Validators.required, CustomValidators.teamnameValidator(this.teamForm.controls.entityId, _teams,this.team.name)]);
  }

}
